import { NavLink, useNavigate } from "react-router-dom";
import { ADMIN_NAV } from "lib/adminNav";
import { useAuth } from "lib/auth";
import { useResource } from "hooks/useResource";
import { getSettings } from "services/content";
import { mediaUrl } from "lib/media";
import { cn } from "lib/utils";

function Brand() {
  const { data: settings } = useResource(getSettings);
  const logo = mediaUrl(settings?.logo);
  return (
    <div className="px-[22px] pt-[22px] pb-5 border-b border-white/[0.08] flex items-center gap-3">
      <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center overflow-hidden shrink-0">
        {logo ? (
          <img src={logo} alt="Logo" className="w-full h-full object-cover" />
        ) : (
          <svg width="28" height="28" viewBox="0 0 36 36" aria-hidden="true">
            <circle cx="18" cy="18" r="16" fill="#005C40" />
            <ellipse cx="18" cy="16" rx="7" ry="7" fill="#B8002B" />
            <path d="M9 28 Q18 21 27 28" stroke="#f7efc8" strokeWidth="1.8" fill="none" />
          </svg>
        )}
      </div>
      <div>
        <div className="text-white font-serif font-bold text-sm leading-[1.2]">KCGS Admin</div>
        <div className="text-[#7ee8c0] text-[10.5px] font-semibold">Management Console</div>
      </div>
    </div>
  );
}

export default function AdminSidebar() {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleLogout = () => {
    logout();
    navigate("/admin/login", { replace: true });
  };

  return (
    <aside className="w-[248px] bg-green-dark fixed inset-y-0 left-0 flex flex-col z-[100]">
      <Brand />

      <nav className="flex-1 p-3 overflow-y-auto" aria-label="Admin">
        {ADMIN_NAV.map(({ to, end, label, icon }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            className={({ isActive }) =>
              cn(
                "w-full flex items-center gap-3 px-3.5 py-[11px] mb-[3px] rounded-[9px] text-sm transition-all duration-150 border-l-[3px]",
                isActive
                  ? "bg-white/[0.12] text-white font-semibold border-[#7ee8c0]"
                  : "text-[#9fc4b5] font-normal border-transparent hover:bg-white/[0.06]"
              )
            }
          >
            <span className="text-[17px]">{icon}</span>
            {label}
          </NavLink>
        ))}
      </nav>

      <div className="p-3 border-t border-white/[0.08]">
        <button
          onClick={handleLogout}
          className="w-full flex items-center gap-3 px-3.5 py-[11px] rounded-[9px] bg-transparent text-[#e89] text-sm hover:bg-white/[0.06] transition-colors"
        >
          <span className="text-[17px]">🚪</span>Logout &amp; Exit
        </button>
      </div>
    </aside>
  );
}
